import styled from 'styled-components';
import PropTypes from 'prop-types';

import addWebpBackgroundImage from 'styles/addWebpBackgroundImage';

export const ImageContent = styled.div`
  width: 100%;
`;

ImageContent.displayName = 'ImageContent';

export const ResponsiveImageSizeContent = styled.div`
  ${({ path }) => addWebpBackgroundImage(path)}
`;

ResponsiveImageSizeContent.propTypes = {
  path: PropTypes.string.isRequired,
};

ResponsiveImageSizeContent.displayName = 'ResponsiveImageSizeContent';

export const ImageContainer = styled.div`
  display: flex;
  justify-content: ${({ position }) => position};
`;

ImageContainer.propTypes = {
  position: PropTypes.string.isRequired,
};

ImageContainer.displayName = 'ImageContainer';
